import { render, staticRenderFns } from "./BasicDataGrid.vue?vue&type=template&id=0007c378&scoped=true"
import script from "./BasicDataGrid.vue?vue&type=script&lang=js"
export * from "./BasicDataGrid.vue?vue&type=script&lang=js"
import style0 from "./BasicDataGrid.vue?vue&type=style&index=0&id=0007c378&prod&lang=scss&scoped=true"
import style1 from "./BasicDataGrid.vue?vue&type=style&index=1&id=0007c378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007c378",
  null
  
)

export default component.exports